import context from '@/context'
import { addAnswerToComment } from './utils/commentsUtils'

const initialState = {

  fetching: false,
  adding: false,
  comments: []
}

export const actionTypes = {
  ReportSubmissionGroupCommentFetching: 'reportSubmissionGroupComments/fetching',
  ReportSubmissionGroupCommentFetched: 'reportSubmissionGroupComments/fetched',
  ReportSubmissionGroupCommentAdding: 'reportSubmissionGroupComments/adding',
  ReportSubmissionGroupCommentAdded: 'reportSubmissionGroupComments/added',
  Error: 'reportSubmissionGroupComments/error'
}

export const actionCreators = {

  getComments: (id) => (dispatch) => {
    dispatch({ type: actionTypes.ReportSubmissionGroupCommentFetching, data: id })
    context.api.reportSubmissionGroupCommentsService.getComments(id)
      .then(response => {
        dispatch({ type: actionTypes.ReportSubmissionGroupCommentFetched, data: response })
      }).catch(() => dispatch({ type: actionTypes.Error }))
  },

  addComment: (newComment) => (dispatch) => {
    dispatch({ type: actionTypes.ReportSubmissionGroupCommentAdding })
    context.api.reportSubmissionGroupCommentsService.addComment(newComment)
      .then(() => {
        dispatch({ type: actionTypes.ReportSubmissionGroupCommentAdded, data: newComment })
      }).catch(() => dispatch({ type: actionTypes.Error }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ReportSubmissionGroupCommentFetching: return { ...state, fetching: true }
    case actionTypes.ReportSubmissionGroupCommentFetched: return { ...state, fetching: false, comments: action.data }
    case actionTypes.ReportSubmissionGroupCommentAdding: return { ...state, adding: true }
    case actionTypes.ReportSubmissionGroupCommentAdded: return { ...state, adding: false, comments: addAnswerToComment(action.data, state.comments).comments }
    case actionTypes.Error: return { ...state, fetching: false, adding: false }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/ReportSubmissionGroupComments.js